import { HistoryProrvider } from './historyProrvider';
import { getDispatch, getState } from '../store';
import { getAuthUserLangCode, getMainViewMode } from '../store/general/selectors';
import { EMainViewMode } from '../store/general/types';
import { MainLayoutEffects } from './mainLayoutEffects';
import { getUserStateStorage } from '../../common/utils/local-storage/user-state';
import { getAudioByGroupIdAndId, getVideoByGroupIdAndKey } from '../store/models/selectors';
import { TextSelectors } from '../store/text/selectors';
import { TextActions } from '../store/text/actions';
import { IContentLibOptions } from '../types/common';
import { ContentLibSelectors } from '../store/contentLib/selectors';
import { PlayListLevelTitles } from '../components/dashboard/PlayList/PlayListLevelSelect/types';

const _history = HistoryProrvider.getHistory();

export class Navigator {

  public static openVideo(groupId: number, videoId: string, phraseId?: number, pause?: boolean) {
    if (!groupId || !videoId) return;

    const userStorage = getUserStateStorage();
    userStorage.setVideoInfo(videoId, groupId, 0);
    userStorage.setLibraryGroupId(groupId);

    const list = [groupId, videoId];
    if (phraseId !== undefined) {
      list.push(phraseId);
    }
    if (pause !== undefined) {
      list.push(pause ? '1' : '0');
    }
    const url = '/video/' + list.join('/');
    _history.push(url);

    if (getMainViewMode(getState()) === EMainViewMode.PLAYLISTS) {
      getDispatch()(MainLayoutEffects.backToDashboard());
    }

    if (TextSelectors.getTextActiveId(getState())) getDispatch()(TextActions.update({
      activeId: null as any,
    }));
  }

  public static openAudio(groupId: number, audioId: number) {
    const userStorage = getUserStateStorage();
    userStorage.setAudioInfo(audioId, groupId);
    userStorage.setLibraryGroupId(groupId);

    const url = '/audio/' + [groupId, audioId].join('/');
    _history.push(url);

    if (TextSelectors.getTextActiveId(getState())) getDispatch()(TextActions.update({
      activeId: null as any,
    }));
  }

  public static getURLContentLib ({
    groupId,
    langCode,
  }: IContentLibOptions = {}): string {
    const state = getState();
    let url = '/contentLib';

    if (!langCode) langCode = getAuthUserLangCode(state);
    url += '/' + langCode;

    if (groupId) {
      url += '/group/' + groupId;
    } else {
      const selectedCategoryId = ContentLibSelectors.getSelectedCategoryId(state);
      if (selectedCategoryId) {
        const categories = ContentLibSelectors.getCategories(state);
        const category = categories.find(item => item.id === selectedCategoryId);
        if (category) {
          let arr = category.name.split(' ');
          url += '/' + arr[0].toLowerCase();
        }
      }

      const { level } = ContentLibSelectors.getSearchFilter(state);
      if (+level) {
        url += '/' + PlayListLevelTitles[level].toLocaleLowerCase();
      }
      
    }
    return url;
  }

  public static openContentLib ({
    groupId,
    langCode,
  }: IContentLibOptions = {}): void {
    let url = this.getURLContentLib({groupId, langCode});
    _history.push(url);
  }

  public static navigateContentLib ({
    groupId,
    langCode,
  }: IContentLibOptions = {}): void {
    let url = this.getURLContentLib({groupId, langCode});
    window.history.pushState('', '', url);
  }

  public static openMyStuff(groupId?: number) {
    const url = '/myStuff' + (groupId ? '/' + groupId : '');
    _history.push(url);
  }

  public static openDefault() {
    const data = getUserStateStorage().getData();
    if (data.groupId) {
      if (data.audioId) {
        const audio = getAudioByGroupIdAndId(getState(), data.groupId, data.audioId);
        if (audio) {
          this.openAudio(data.groupId, data.audioId);
          return;
        }
      } else if (data.videoId) {
        const video = getVideoByGroupIdAndKey(getState(), data.groupId, data.videoId);
        if (video) {
          this.openVideo(data.groupId, data.videoId);
          return;
        }
      }
    }
    _history.push('/');
  }

  public static openInstallSelectLangs() {
    _history.push('/install/selectLangs');
  }

  public static openGroup(groupId: number) {
    _history.push(`/video/${groupId}/`);
  }

  public static openUrl(url: string) {
    _history.push(url);
  }

  public static openPublicProfile(userName: string) {
    const url = '/@' + userName;
    _history.push(url);
  }

  public static openVideoRecent() {
    _history.push('/videoRecent');
  }

  public static openSettings() {
    _history.push('/settings');
  }

}
